import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  IDataUserLocalStorage,
  PRE_ACTION_AUTHENTICATION_URL,
  USER_AUTH_SLICE,
  UserAuth,
} from "./userAuth.constant";
import { axiosPublic } from "../../../config/axios";
import { localStorageService } from "../../../service/localStorage.service";
import { resetNavigate } from "../../../utilities/navigation";
import { ILoginModel } from "../../../models/login";

export const login = createAsyncThunk(
  `${USER_AUTH_SLICE}/login`,
  async (user: ILoginModel, thunkAPI: any) => {
    try {
      const res = await axiosPublic.post(
        `${PRE_ACTION_AUTHENTICATION_URL}/login`,
        user
      );
      return res?.data as UserAuth;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const refreshToken = createAsyncThunk(
  `${USER_AUTH_SLICE}/refresh`,
  async (_, thunkAPI: any) => {
    try {
      if (
        localStorageService.getItem<IDataUserLocalStorage>("auth-user") === null
      ) {
        resetNavigate("/auth/login");
        return null;
      }
      const res = await axiosPublic.post(
        `${PRE_ACTION_AUTHENTICATION_URL}/refresh`,

        localStorageService.getItem<IDataUserLocalStorage>("auth-user")
      );

      return res.data as UserAuth;
    } catch (error: any) {
      resetNavigate("/auth/login");
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const refreshTokenInUse = createAsyncThunk(
  `${USER_AUTH_SLICE}/refresh-in-use`,
  async (_, thunkAPI: any) => {
    try {
      if (
        localStorageService.getItem<IDataUserLocalStorage>("auth-user") === null
      ) {
        resetNavigate("/auth/login");
        return null;
      }
      const res = await axiosPublic.post(
        `${PRE_ACTION_AUTHENTICATION_URL}/refresh`,

        localStorageService.getItem<IDataUserLocalStorage>("auth-user")
      );

      return res.data?.data as UserAuth;
    } catch (error: any) {
      resetNavigate("/auth/login");
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// export const logout = createAsyncThunk(
//   `${USER_AUTH_SLICE}/logout`,
//   async (_, thunkAPI: any) => {
//     try {
//       const res = await axiosPublic.post(
//         `${VERSION_API}/${PRE_ACTION_AUTHENTICATION_URL}/logout`,
//         {
//           refreshToken:
//             localStorageService.getItem<IDataUserLocalStorage>(
//               "auth-user-customer"
//             )?.refreshToken,
//         }
//       );
//       localStorageService.removeItem("auth-user-customer");

//       return res.data as UserAuth;
//     } catch (error: any) {
//       const dataError: IErrorResponse = error;

//       return thunkAPI.rejectWithValue(error);
//     }
//   }
// );
